var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbsLacenIconAppI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93.36 92.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-d3c45bb3-4140-4e5c-beec-b0f777de3da3{fill:#fff;}.uuid-b22a0108-8e48-4798-b782-132d5e39f1a8{fill:#bfbfbf;}.uuid-1ea9a48c-8970-47b4-a340-529a16faa97f{filter:url(#uuid-d27d73dd-3b2d-46f6-a581-2a1a0e9fdf0a);}.uuid-764b7e00-37bf-420b-9e8c-33176bfe5cdc{fill:#003b3f;}.uuid-5cb7b9ed-7356-4b0e-9b64-071f2d0a6049{fill:#7fcc97;}.uuid-67d75d65-427c-499b-9cfa-b965968bdde5{mask:url(#uuid-31bc2377-b0b7-4523-be42-e8601d05897e);}.uuid-67d75d65-427c-499b-9cfa-b965968bdde5,.uuid-a51ea59b-bcd4-4eba-9649-99055ab21083,.uuid-95b3063b-5a92-4cf6-a190-23f60b1a2c9d{fill:none;}.uuid-a51ea59b-bcd4-4eba-9649-99055ab21083{isolation:isolate;}.uuid-2adf569e-dd50-4dcd-9b4a-4a2f4d18c17a{fill:url(#uuid-07bb5522-f6bd-4df6-b8cc-4d527ad56502);}.uuid-95b3063b-5a92-4cf6-a190-23f60b1a2c9d{mix-blend-mode:multiply;opacity:.75;}"), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-d27d73dd-3b2d-46f6-a581-2a1a0e9fdf0a",
    x: -1.88,
    y: -2.55,
    width: 97,
    height: 98,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "uuid-31bc2377-b0b7-4523-be42-e8601d05897e",
    x: -1.88,
    y: -2.55,
    width: 97,
    height: 98,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-1ea9a48c-8970-47b4-a340-529a16faa97f"
  }, /*#__PURE__*/React.createElement("image", {
    width: 97,
    height: 98,
    transform: "translate(-1.88 -2.55)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-07bb5522-f6bd-4df6-b8cc-4d527ad56502",
    x1: -337.55,
    y1: -549.19,
    x2: -324.91,
    y2: -549.19,
    gradientTransform: "translate(644.66 224.98) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f2f0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1f0ed",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c9e3ce",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a9d9b6",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#92d2a5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#84cd9a",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7fcc97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-a51ea59b-bcd4-4eba-9649-99055ab21083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-f8485019-361e-429b-a10c-313c765fb51e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-764b7e00-37bf-420b-9e8c-33176bfe5cdc",
    x: 0.29,
    width: 92.8,
    height: 92.8,
    rx: 18.55,
    ry: 18.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-67d75d65-427c-499b-9cfa-b965968bdde5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-95b3063b-5a92-4cf6-a190-23f60b1a2c9d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-b22a0108-8e48-4798-b782-132d5e39f1a8",
    x: 0.29,
    width: 92.8,
    height: 92.8,
    rx: 18.55,
    ry: 18.55
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-2adf569e-dd50-4dcd-9b4a-4a2f4d18c17a",
    points: "32.41 72.22 20.68 60.49 11.8 69.5 23.53 81.23 32.41 72.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-5cb7b9ed-7356-4b0e-9b64-071f2d0a6049",
    x: 30.55,
    y: 45.76,
    width: 16.59,
    height: 16.59,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-26.85 43.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d3c45bb3-4140-4e5c-beec-b0f777de3da3",
    d: "m51.54,27.81h0c-2.46,2.46-3.43,6.06-2.52,9.42h0c.9,3.37,3.53,6,6.9,6.9h0c3.37.9,6.96-.06,9.42-2.52h0c2.46-2.46,3.43-6.06,2.52-9.42h0c-.9-3.37-3.53-6-6.9-6.9h0c-3.37-.9-6.96.06-9.42,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5cb7b9ed-7356-4b0e-9b64-071f2d0a6049",
    d: "m81.57,44.51v11.91c0,.78-.64,1.42-1.42,1.42h-11.91c-1.27,0-1.9-1.53-1-2.42l11.91-11.91c.89-.89,2.42-.26,2.42,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5cb7b9ed-7356-4b0e-9b64-071f2d0a6049",
    d: "m48.63,11.57h-11.91c-.78,0-1.42.64-1.42,1.42v11.91c0,1.27,1.53,1.9,2.42,1l11.91-11.91c.89-.89.26-2.42-1-2.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbsLacenIconAppI);
export default __webpack_public_path__ + "static/media/cbs-lacen-icon-app-i.ebe2e00cd5a44823b7992bf218de0149.svg";
export { ForwardRef as ReactComponent };